import useLogout from '@/hooks/useLogout';
import LogoutButton from './LogoutButton.component';

const LogoutContainer = function (): JSX.Element {
  const logout = useLogout();

  return <LogoutButton handleLogout={logout} />;
};

export default LogoutContainer;
